import { HttpClient, HttpResponse } from '@wix/http-client';

const BASE = '/_serverless/cc-user-facing-service/article';

const httpClient = new HttpClient();

export const followArticleRequest = async (
  articleId: string,
  locale: string
): Promise<void> => {
  await httpClient.post(`${BASE}/follow`, { articleId, locale });
};

export const unfollowArticleRequest = async (
  articleId: string,
  locale: string
): Promise<void> => {
  await httpClient.post(`${BASE}/unfollow`, { articleId, locale });
};

export const isFollowingArticleRequest = async (
  articleId: string,
  locale: string
): Promise<boolean> => {
  try {
    const { data } = (await httpClient.get(`${BASE}/is-following`, {
      params: { articleId, locale },
    })) as HttpResponse<{ isFollowing: boolean }>;
    return Boolean(data?.isFollowing);
  } catch (_) {
    return false;
  }
};
